import { toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createBlock as _createBlock, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "no-tabs notifications" }
const _hoisted_2 = { class: "action-panel mb-3" }
const _hoisted_3 = { class: "fw-bold fs-6 mb-1 vehicle-name" }
const _hoisted_4 = { class: "fs-6 mb-1 vehicle-imei" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_NotificationsModal = _resolveComponent("NotificationsModal")!
  const _component_DxSelection = _resolveComponent("DxSelection")!
  const _component_DxHeaderFilter = _resolveComponent("DxHeaderFilter")!
  const _component_DxPaging = _resolveComponent("DxPaging")!
  const _component_DxPager = _resolveComponent("DxPager")!
  const _component_DxFilterRow = _resolveComponent("DxFilterRow")!
  const _component_DxColumnFixing = _resolveComponent("DxColumnFixing")!
  const _component_DxSearchPanel = _resolveComponent("DxSearchPanel")!
  const _component_DxColumn = _resolveComponent("DxColumn")!
  const _component_DxDataGrid = _resolveComponent("DxDataGrid")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.selectedItems.length > 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 0,
            class: "btn btn-danger",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.confirmDelete && _ctx.confirmDelete(...args)))
          }, _toDisplayString(_ctx.$t('components.notificationsHistory.dataGrids.deleteSelected')), 1))
        : _createCommentVNode("", true),
      (_ctx.selectedItems.length == 0)
        ? (_openBlock(), _createElementBlock("a", {
            key: 1,
            class: "btn btn-warning",
            onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.openDeleteAllModal && _ctx.openDeleteAllModal(...args)))
          }, _toDisplayString(_ctx.$t('components.notificationsHistory.dataGrids.deleteAll')), 1))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_NotificationsModal, {
      visible: _ctx.deleteAllModalVisible,
      onClose: _ctx.closeDeleteAllModal,
      onRefreshDataGrid: _ctx.refreshDataGrid
    }, null, 8, ["visible", "onClose", "onRefreshDataGrid"]),
    _createVNode(_component_DxDataGrid, {
      ref: _ctx.dataGridRef,
      "allow-column-reordering": true,
      "allow-column-resizing": true,
      "column-auto-width": true,
      "column-hiding-enabled": true,
      "data-source": _ctx.customDataSource,
      "hover-state-enabled": true,
      "remote-operations": _ctx.remoteOperations,
      "show-borders": true,
      "show-column-lines": true,
      onSelectionChanged: _ctx.onSelectionChanged,
      class: "notifications-history-grid"
    }, {
      "vehicle-cell-template": _withCtx(({ data }) => [
        _createElementVNode("p", _hoisted_3, _toDisplayString(data.data.vehicle?.vars?.name || data.data.vehicle?.registration || 'N/A'), 1),
        _createElementVNode("p", _hoisted_4, [
          _cache[2] || (_cache[2] = _createElementVNode("b", null, "IMEI:", -1)),
          _createTextVNode(" " + _toDisplayString(data.data.notificationHistory?.data_last_audit?.data_last?.imei || 'N/A'), 1)
        ])
      ]),
      default: _withCtx(() => [
        (_ctx.adminOrBoss)
          ? (_openBlock(), _createBlock(_component_DxSelection, {
              key: 0,
              "show-check-boxes-mode": _ctx.showCheckBoxesMode,
              mode: "multiple"
            }, null, 8, ["show-check-boxes-mode"]))
          : _createCommentVNode("", true),
        _createVNode(_component_DxHeaderFilter, { visible: false }),
        _createVNode(_component_DxPaging, { "page-size": _ctx.pageSize }, null, 8, ["page-size"]),
        _createVNode(_component_DxPager, {
          "show-info": true,
          "show-navigation-buttons": true,
          visible: true,
          "allowed-page-sizes": [10, 20, 50, 100],
          "show-page-size-selector": true
        }),
        _createVNode(_component_DxFilterRow, { visible: false }),
        _createVNode(_component_DxColumnFixing, { enabled: true }),
        _createVNode(_component_DxSearchPanel, {
          visible: true,
          width: 140,
          placeholder: _ctx.$t('components.notificationsHistory.dataGrids.search')
        }, null, 8, ["placeholder"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          "allow-header-filtering": false,
          caption: "#",
          "filter-operations": _ctx.allowedOperations,
          "data-field": "notificationHistory.id",
          width: _ctx.columnWidths.id
        }, null, 8, ["filter-operations", "width"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          caption: _ctx.$t('components.notificationsHistory.dataGrids.email'),
          "data-field": "notificationHistory.email",
          width: _ctx.columnWidths.email
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          caption: _ctx.$t('components.notificationsHistory.dataGrids.vehicle'),
          "data-field": "full_vehicle_details",
          "cell-template": "vehicle-cell-template",
          width: _ctx.columnWidths.vehicle
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          caption: _ctx.$t('components.notificationsHistory.dataGrids.isSentEmail'),
          "data-field": "notificationHistory.is_sent_by_email",
          width: _ctx.columnWidths.isSentEmail
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          caption: _ctx.$t('components.notificationsHistory.dataGrids.isSentSms'),
          "data-field": "notificationHistory.is_sent_by_sms",
          width: _ctx.columnWidths.isSentSms
        }, null, 8, ["caption", "width"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          caption: _ctx.$t('components.notificationsHistory.dataGrids.message'),
          "data-field": "notificationHistory.message",
          "cell-template": _ctx.renderTranslatedMessage,
          width: _ctx.columnWidths.message
        }, null, 8, ["caption", "cell-template", "width"]),
        _createVNode(_component_DxColumn, {
          "allow-filtering": true,
          caption: _ctx.$t('components.notificationsHistory.dataGrids.sentAt'),
          "data-field": "notificationHistory.sent_at",
          "cell-template": _ctx.sentAtTemplate,
          width: _ctx.columnWidths.sentAt
        }, null, 8, ["caption", "cell-template", "width"])
      ]),
      _: 1
    }, 8, ["data-source", "remote-operations", "onSelectionChanged"])
  ]))
}